import {
  Injectable,
  ComponentFactoryResolver,
  ApplicationRef,
  Injector,
  Optional,
  EmbeddedViewRef
} from "@angular/core";
import { Observable } from "rxjs";
import { FileBrowserComponent } from "./components/file-browser.component";

export interface DialogOptions {
  index?: number;
  autoCloseTimeout?: number;
  closeByClickingOutside?: boolean;
  backdropColor?: string;
}

export class FileBrowserServiceConfig {
  container: HTMLElement = null;
}

@Injectable({
  providedIn: "root"
})
export class FileBrowserService {
  static browse(field_name: any, url: any, type: any, win: any) {
    win.document.getElementById(field_name).value = "my browser value";
  }

  pick(callback, value, meta) {
    if (meta.filetype == "file") {
      callback("mypage.html", { text: "My text" });
    }

    // Provide image and alt text for the image dialog
    if (meta.filetype == "image") {
      callback("myimage.jpg", { alt: "My alt text" });
    }

    // Provide alternative source and posted for the media dialog
    if (meta.filetype == "media") {
      callback("movie.mp4", { source2: "alt.ogg", poster: "image.jpg" });
    }
  }

  /**
   * HTML container for dialogs
   * type {HTMLElement}
   */
  private container: HTMLElement;

  /**
   * @param {ComponentFactoryResolver} resolver
   * @param {ApplicationRef} applicationRef
   * @param {Injector} injector
   * @param {DialogServiceConfig} config
   */

  currentDialog: FileBrowserComponent;

  openDialog(options?): Observable<any> {
    if (!this.currentDialog) {
      this.currentDialog = this.createDialog();
    }
    return this.currentDialog.present(options);
  }

  private createDialog(): FileBrowserComponent {
    let componentFactory = this.resolver.resolveComponentFactory(
      FileBrowserComponent
    );

    let componentRef = componentFactory.create(this.injector);
    let componentRootNode = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;
    if (!this.container) {
      let componentRootViewContainer = this.applicationRef["components"][0];

      this.container = (componentRootViewContainer.hostView as EmbeddedViewRef<
        any
      >).rootNodes[0] as HTMLElement;
    }
    this.applicationRef.attachView(componentRef.hostView);

    componentRef.onDestroy(() => {
      this.applicationRef.detachView(componentRef.hostView);
    });
    this.container.appendChild(componentRootNode);

    return componentRef.instance;
  }

  public custom_filebrowser(field_name, url, type, win) {
    const mcewins = document.getElementsByClassName("mce-window");
    const arr = Array.from(mcewins);
    let tempStyle = "";
    for (let item of arr) {
      tempStyle = item.getAttribute("style");
      item.setAttribute("style", "position:relative; opacity : 0;");
    }
    document.getElementById("mce-modal-block").style.visibility = "hidden";

    this.openDialog({ picker: true }).subscribe(medias => {
      if (!medias.length) return;
      win.document.getElementById(field_name).value = medias[0].data;

      for (let item of arr) {
        item.setAttribute("style", tempStyle);
      }
    });
  }

  constructor(
    private resolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector,
    @Optional() config: FileBrowserServiceConfig
  ) {
    this.container = config && config.container;
  }
}
